import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Elements } from '@stripe/react-stripe-js'

import { useIsDarkMode } from '~/hooks/use-is-dark-mode'
import { getStripe } from '~/utils/get-stripe'
import { getStripeElementsOptions } from '~/utils/get-stripe-elements-options'
import { langWithoutRegion } from '~/utils/lang-without-region'

type StripeElementsProps = PropsWithChildren<{
  clientSecret: string
}>

export const StripeElements = ({ clientSecret, children }: StripeElementsProps) => {
  const { i18n } = useTranslation()
  const isDarkMode = useIsDarkMode()
  const language = langWithoutRegion(i18n.language)

  return (
    <Elements
      key={language}
      options={getStripeElementsOptions(clientSecret, language, isDarkMode)}
      stripe={getStripe()}
    >
      {children}
    </Elements>
  )
}
